import React from 'react';
import classNames from 'classnames';
import { Image } from '@wix/image';
import {
  getImageUri,
  isExperimentEnabled,
  type MediaPlatformImage,
} from '@wix/communities-blog-client-common';
import { OOI_EXPERIMENTS } from '@app/experiments';
import { AvatarPlaceholder } from '../icons/avatar-placeholder';
import { useSelector } from '../runtime-context';
import styles from './fluid-avatar-image.scss';

interface Props {
  image?: MediaPlatformImage;
  size: number;
  ariaLabel: string;
}

const FluidAvatarImage: React.FC<Props> = ({ image, size, ariaLabel }) => {
  const uri =
    getImageUri(image) ?? (image && 'url' in image ? image.url : undefined);

  const isAvifEncodingEnabled = useSelector((state) =>
    isExperimentEnabled(state, OOI_EXPERIMENTS.USE_AVIF_ENCODING),
  );

  if (!uri) {
    return (
      <span
        aria-label={ariaLabel}
        className={classNames(styles.container, 'fluid-avatar-image')}
        data-hook="avatar-image"
        role="img"
      >
        <AvatarPlaceholder className={styles.placeholder} />
      </span>
    );
  }

  return (
    <Image
      alt={ariaLabel}
      className={classNames(styles.container, 'fluid-avatar-image')}
      uri={uri}
      displayMode="fill"
      width={size}
      height={size}
      targetWidth={size}
      targetHeight={size}
      data-hook="avatar-image"
      role="img"
      encoding={isAvifEncodingEnabled ? 'AVIF' : undefined}
    />
  );
};

export default FluidAvatarImage;
